import { ErrorResponse } from "@robe/core-api/baseApiRequest";
import { XcoreError } from "./XcoreError";

export class InternalServerError extends XcoreError {
  public name: "InternalServerError" = "InternalServerError" as const;

  public response: Response;

  public error?: ErrorResponse;

  constructor(url: string, res: Response, errorResponse?: ErrorResponse) {
    super(url, errorResponse?.detail ?? "InternalServerError");
    this.response = res;
    this.error = errorResponse;
  }
}
